// Copied from Tfs\Service\WebAccess\WorkItemTracking\Scripts\OM\QueryConstants.ts
/// <amd-module name="Wit/Common/QueryUtils/QueryTypeConstants" />
import { QueryType } from "Wit/Clients/Wit/Contracts/WorkItemTracking";

export namespace LinkQueryMode {
    export const Unknown = 0;
    export const WorkItems = 1;
    export const LinksMustContain = 2;
    export const LinksMayContain = 3;
    export const LinksDoesNotContain = 4;
    export const LinksRecursive = 5;
    export const LinksRecursiveReturnMatchingChildren = 6;

    export function isLinkQuery(mode: number): boolean {
        return (mode || LinkQueryMode.Unknown) > LinkQueryMode.WorkItems;
    }

    export function isTreeQuery(mode: number): boolean {
        return (mode || LinkQueryMode.Unknown) >= LinkQueryMode.LinksRecursive;
    }

    export function getQueryType(mode: number): QueryType {
        if (isTreeQuery(mode)) {
            return QueryType.Tree;
        } else if (isLinkQuery(mode)) {
            return QueryType.OneHop;
        } else {
            return QueryType.Flat;
        }
    }
}
